<template>
  <div
    v-if="banner"
    class="banner"
    :class="{
      'banner--animated': banner.hasAnimated,
      'banner--hidden': shouldHide,
    }"
  >
    <div class="banner__inner">
      <p class="banner__lead">
        {{ banner.title }}
      </p>

      <button v-if="banner.action" type="button" class="button-reset banner__button" @click="handleAction">
        <span>{{ banner.action.title }}</span>
        <MoveRight />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MoveRight } from 'lucide-vue'
import { eventBus } from '@/helpers'

export default {
  name: 'Banner',
  components: {
    MoveRight,
  },
  computed: {
    ...mapGetters(['banner', 'bannerHasAnimated']),
    shouldHide() {
      return this.banner?.hideOnRouteNames?.includes(this.$route.name)
    },
  },
  watch: {
    banner: {
      handler() {
        if (this.banner?.hasAnimated === false) {
          this.animationEndHandler()
        }
      },
      immediate: true,
    },
  },
  methods: {
    animationEndHandler() {
      setTimeout(() => {
        this.$store.commit('SET_BANNER_ANIMATED', true)
      }, 1000)
    },
    handleAction() {
      if (!this.banner.action) {
        return
      }

      if (this.banner.action.type === 'readyOrders') {
        const orderIds = this.banner.action.orderIds

        if (orderIds.length === 1) {
          this.$router.push({
            name: 'delivery',
            params: { deliveryId: this.banner.action.orderIds[0], initiateReceipt: true },
          })
        } else {
          eventBus.$emit('modal', {
            component: 'ReadyOrdersModal',
            data: {},
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.banner {
  overflow: hidden;
  position: relative;

  &:not(.banner--animated) {
    animation: slideDown 1s ease;
  }

  &.banner--hidden {
    display: none;
  }

  &__inner {
    padding: 8px 16px;
    background-color: $Yellow3;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    position: relative;
    font-weight: 500;
  }

  &__button {
    background-color: $White;
    padding: 4px 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    white-space: nowrap;

    &::after {
      position: absolute;
      cursor: pointer;
    }

    > svg {
      width: 16px;
      height: 16px;
      transition: color 300ms ease;
    }

    &:hover > svg {
      color: $GreenM;
    }
  }

  @keyframes slideDown {
    from {
      max-height: 0;
    }

    to {
      max-height: 200px;
    }
  }
}
</style>
